<lib-page-container [loading]="screen.isLoading()" [title]="(isAdding || isCloning) ? 'Add PunchCard Campaign' : 'Edit PunchCard Campaign'"
  [version]="appVersion.version" [apiVersion]="appVersion.apiVersion$ | async">
  <div lib-page-breadcrumbs>
    <lib-breadcrumbs></lib-breadcrumbs>
  </div>
  <div lib-page-actions>
    <lib-button [disabled]="screen.isLoading()" *appHasAnyPermission="[permissions.CAMPAIGNMANAGEMENT_WRITE, permissions.CAMPAIGN_UPDATE]" icon="save"
    (buttonClick)="onSave()">Save</lib-button>
  </div>
  <div lib-page-body>
    <mat-tab-group class="tab-group">
      <mat-tab>
        <ng-template mat-tab-label>
          Main Information
          @if (isMainInformationValid === false) {
            <mat-icon class="tab-icon">warning</mat-icon>
          }
        </ng-template>
        <div class="flex-row gap-16 basic-info">
          <app-campaign-base-edit style="width: 490px;" #campaignBase [campaign]="campaign" [isStaffCampaign]="isStaffSelected"
          (isContactSync)="contactSyncChanged($event)" (isDataConsumerSync)="dataConsumerSyncChanged($event)"></app-campaign-base-edit>

          <mat-card appearance="outlined" class="flex-1">
            <mat-card-content>
              <mat-tab-group alignTabs="start">
                <mat-tab>
                  <ng-template mat-tab-label>
                    Target Roles
                    @if (campaignTargetRole && campaignTargetRole.isValid() === false) {
                      <mat-icon class="tab-icon">warning</mat-icon>
                    }
                  </ng-template>
                  <app-target-role-tab #campaignTargetRole [campaign]="campaign" (onTargetRoleChanged)="onTargetRoleChange($event)"></app-target-role-tab>
                </mat-tab>
                <mat-tab>
                  @if (campaign) {
                    <ng-template mat-tab-label>
                      Capture Tools
                      @if (campaignStrategyReceipt && campaignStrategyReceipt?.isValid() === false) {
                        <mat-icon class="tab-icon">warning</mat-icon>
                      }
                    </ng-template>
                    <app-punch-card-strategy-receipt #campaignStrategyReceipt [isContactSync]="isContactSync" (onCaptureToolTypeChanged)="onCaptureToolChange($event)" [campaignId]="campaignId" [originalCampaignId]="originalCampaignId" [advertiserId]="advertiserId" [strategy]="campaign.strategy"></app-punch-card-strategy-receipt>
                  } @else {
                    <ng-template mat-tab-label>
                      Capture Tools
                    </ng-template>
                  }
                </mat-tab>
                <mat-tab>

                  @if (campaign) {
                    <ng-template mat-tab-label>
                      Strategy
                      @if (campaignStrategy && !campaignStrategy.isValid()) {
                        <mat-icon class="tab-icon">warning</mat-icon>
                      }
                    </ng-template>
                    <app-punch-card-strategy #campaignStrategy [strategyType]="strategyType" [baseCalculation]="baseCalculation" [currencyCode]="currencyCode" [captureToolType]="captureToolType" [campaign]="campaign"(onBaseCalculationChanged)="onBaseCalculationChange($event)" (onCurrencyChanged)="onCurrencyChange($event)" (onStrategyTypeChanged)="onStrategyChange($event)" (onSchemeChanged)="onSchemeChanged($event)"></app-punch-card-strategy>
                  } @else {
                    <ng-template mat-tab-label>
                      Strategy
                    </ng-template>
                  }
                </mat-tab>
                <mat-tab>
                  @if (campaign) {
                    <ng-template mat-tab-label>
                      Tiers
                      @if (campaignStrategyFlow && campaignStrategyFlow.isValid() === false) {
                        <mat-icon class="tab-icon">warning</mat-icon>
                      }
                    </ng-template>
                    <app-punch-card-strategy-flow #campaignStrategyFlow [strategyType]="strategyType" [campaignId]="campaignId" [advertiserId]="advertiserId" [strategy]="campaign.strategy" [isAdding]="isAdding" [isCloning]="isCloning" (allowFlowChange)="onAllowFlowChange($event)"></app-punch-card-strategy-flow>
                  } @else {
                    <ng-template mat-tab-label>
                      Tiers
                    </ng-template>
                  }
                </mat-tab>
                <mat-tab label="Locations">
                  <app-campaign-location-filters #campaignLocationFilters [campaignId]="campaignId"></app-campaign-location-filters>
                </mat-tab>
                <mat-tab>
                  <ng-template mat-tab-label>
                    Banners
                    @if (campaignBanner && campaignBanner.isValid() === false) {
                      <mat-icon class="tab-icon">warning</mat-icon>
                    }
                  </ng-template>
                  <app-campaign-banner #campaignBanner [bannerDuration]="bannerDuration" [showBannerDuration]="true"></app-campaign-banner>
                </mat-tab>
                <mat-tab>
                  <ng-template mat-tab-label>
                    Outbound Events
                    @if (campaignOutboundEvents && campaignOutboundEvents.isValid() === false) {
                      <mat-icon class="tab-icon">warning</mat-icon>
                    }
                  </ng-template>
                  <app-campaign-outbound-events #campaignOutboundEvents [campaignId]="campaignId"></app-campaign-outbound-events>
                </mat-tab>
              </mat-tab-group>
            </mat-card-content>
          </mat-card>
        </div>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          Consumer Referral
          @if (consumerReferralTab && consumerReferralTab.isValid() === false) {
            <mat-icon class="tab-icon">warning</mat-icon>
          }
        </ng-template>
        <app-consumer-referral-tab #consumerReferralTab [isPunchCard]="true" [isPoints]="strategyType == 'Points'" [campaignId]="campaignId" [advertiserId]="advertiserId"></app-consumer-referral-tab>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          Staff Referral
          @if (staffReferralTab && staffReferralTab.isValid() === false) {
            <mat-icon class="tab-icon">warning</mat-icon>
          }
        </ng-template>
        <app-staff-referral-tab #staffReferralTab [campaignId]="campaignId" [advertiserId]="advertiserId"></app-staff-referral-tab>
      </mat-tab>
      <mat-tab label="Media">
        @if (campaignId) {
          <app-campaign-media #campaignMedia [campaignId]="campaignId"></app-campaign-media>
        }
      </mat-tab>
      <mat-tab label="Json">
        <pre>{{ campaign | json }}</pre>
      </mat-tab>
    </mat-tab-group>
  </div>
</lib-page-container>
@if (screen.isLoading()) {
  <lib-loading-overlay />
}
